import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import StrategyBriefHubStepLayout from '@/brief-hub/common/ui/layout/StrategyBriefHubStepLayout.vue';
    import {useBriefStrategyStore} from '@/brief-hub/stores/briefStrategy.store';
    import {
        FreelancerAvailability,
        StrategyWhereConditionsBriefRequest,
        WhereConditionsBriefRequest,
        WorkingStatusRequest,
    } from '@/common/api/api-raw-types';
    import RemoteChoices from '@/common/components/remote-choices/RemoteChoices.vue';
    import {useBriefAmplitudeEvent} from '@/common/composable/useBriefAmplitudeEvent';
    import {WORKED_DAYS_MAPPING} from '@/common/config/variables';
    import {useGlobalProperties} from '@malt/vue3-use';
    import {computed, onMounted, ref, watch} from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'StrategyBriefConditionsWhere',
  setup(__props) {

    const {$features} = useGlobalProperties();
    const briefStrategyStore = useBriefStrategyStore();
    const {triggerBriefFunnelStepEnteredAmplitudeEvent} = useBriefAmplitudeEvent();

    const remoteChoices = ref<StrategyWhereConditionsBriefRequest | undefined>({
        address: briefStrategyStore.briefStrategyWhereConditions.address?.formattedAddress
            ? briefStrategyStore.briefStrategyWhereConditions.address
            : undefined,
        remoteFrequency: briefStrategyStore.briefStrategyWhereConditions.remoteFrequency || undefined,
        workingStatus: briefStrategyStore.briefStrategyWhereConditions.workingStatus || undefined,
    });
    const freelancerAvailability = computed<number | null>(() => briefStrategyStore.briefStrategyWhereConditions.freelancerAvailability);
    const frequencyLimit = computed<number>(() => {
        const {selectedDuration} = briefStrategyStore.briefStrategyConditionsWhen;
        if (selectedDuration && selectedDuration.value < 5 && selectedDuration.unit === 'DAYS') {
            let freelancerAvailability = FreelancerAvailability.FULL_TIME;
            switch (selectedDuration.value) {
                case 2:
                    freelancerAvailability = FreelancerAvailability.TWO_DAYS_PER_WEEK;
                    break;
                case 3:
                    freelancerAvailability = FreelancerAvailability.THREE_DAYS_PER_WEEK;
                    break;
                case 4:
                    freelancerAvailability = FreelancerAvailability.FOUR_DAYS_PER_WEEK;
                    break;
            }
            return WORKED_DAYS_MAPPING[freelancerAvailability];
        }

        if (freelancerAvailability.value) {
            return WORKED_DAYS_MAPPING[freelancerAvailability.value];
        }

        return null;
    });
    const hideHybrid = computed<boolean>(() => {
        const {selectedDuration} = briefStrategyStore.briefStrategyConditionsWhen;
        return selectedDuration?.value === 1 && selectedDuration?.unit === 'DAYS';
    });
    const isFormValid = ref<boolean>(false);

    function handleUpdateChoices(value: WhereConditionsBriefRequest, valid: boolean) {
        remoteChoices.value = {
            address: value.address,
            remoteFrequency: value.remoteFrequency,
            workingStatus: value.workingStatus || WorkingStatusRequest.REMOTELY,
        };
        isFormValid.value = valid;
    }

    onMounted(() => {
        triggerBriefFunnelStepEnteredAmplitudeEvent('condition_where', 6);
    });

    watch(
        remoteChoices,
        () => {
            if (isFormValid.value && remoteChoices.value) {
                briefStrategyStore.updatePayload({
                    type: 'StrategyWhereConditionsBriefRequest',
                    payload: remoteChoices.value,
                });
            } else {
                briefStrategyStore.resetPayload();
            }
        },
        {immediate: true},
    );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(StrategyBriefHubStepLayout, null, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$msg('customer.brief.exec.form.conditions.where.title')), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(RemoteChoices, {
          choices: remoteChoices.value,
          "frequency-limit": frequencyLimit.value,
          "hide-hybrid": hideHybrid.value,
          "onUpdate:choices": handleUpdateChoices
        }, null, 8, ["choices", "frequency-limit", "hide-hybrid"])
      ]),
      _: 1
    })
  ]))
}
}

})